<template>
    <div>
        <section-header
            ref="selectHeader"
            title="Select Row Variable (Required)"
        ></section-header>
        <analysis-variable-selection
            ref="analysisVariableSelection"
            variableType="row"
            :title="''"
            v-model="selectionModel.v.row"
            :isEnabled="true"
            :theVariable="selectionModel.v.row"
            :isRequired="true"
            v-on:variableIsSelected="selectedVariableChanged"
        ></analysis-variable-selection>
        <app-navigator
            ref="appNavigator"
            :router="$router"
            nextButtonTitle="Select a variable to continue"
        ></app-navigator>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import current from '@/scripts/current';
import commonModelHelper from '@/scripts/commonModelHelper';
import store from '@/store';
import sectionHeader from '@/components/sub/sectionHeader';
import appNavigator from '@/components/layout/appNavigator';
import analysisVariableSelection from '@/components/analysisVariableSelection';

export default {
    components: {
        sectionHeader,
        appNavigator,
        analysisVariableSelection
    },
    created: function () {
        const vm = this;
        current.initializeCrossTabulationValues(vm);
        commonModelHelper.initializeStep(vm, 'rowvariable');
        vm.selectionModel = current.selectionModel;
    },
    mounted: function () {
        const vm = this;
        const omittedVariables = { year: false, location: false };
        vm.$refs.analysisVariableSelection.updateSelection({
            omittedVariables
        });
    },
    data: function () {
        return {
            selectionModel: null,
            isLoaded: false
        };
    },
    methods: { selectedVariableChanged }
};

function selectedVariableChanged(variable) {
    const vm = this;
    vm.selectionModel.v.row = variable;
    store.dispatch('selModel/setReadyForNextStep');
}
</script>

<style scoped>
.spaced-out {
    margin-top: 20px;
    margin-bottom: 20px;
}

.dropdown-menu label.radio input[type='radio'] {
    visibility: hidden;
}

.dropdown-menu label.radio {
    padding-left: 10px;
}
</style>
